export default "__VITE_ASSET__874eacd4__"